import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import Nav from "../components/Navigation/Nav";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import WhoWeAre from "../pages/WhoWeAre";
import Missions from "../pages/Missions";
import Donate from "../pages/Donate";
import Mission from "../pages/Mission";
import Benefactors from "../pages/Benefactors";
import Partners from "../pages/Partners";
import LacorPartner from "../pages/LacorPartner";
import NotFound from "../pages/NotFound";
import News from "../pages/News";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<Nav />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/news" element={<News />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/partners/lacor" element={<LacorPartner />} />
        <Route path="/benefactors" element={<Benefactors />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/missions" element={<Missions />} />
        <Route path="/missions/:id" element={<Mission />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </>
  )
);

export default router;
